import { Component, Input } from '@angular/core';

import {
    TableRowData,
    hasCarrierNumberPlateIncoming,
    hasCarrierNumberPlateOutgoing,
} from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

export type LicensePlateType = 'incoming' | 'outgoing';

@Component({
    selector: 'app-license-plates-display',
    standalone: true,
    imports: [],
    template: ` <span>{{ displayValue }}</span> `,
})
export class LicensePlatesDisplayComponent {
    @Input() value: ColumnValue;
    @Input() row: TableRowData;
    @Input() column: ColumnConfig;
    @Input() index: number = 0;
    @Input() item: TableRowData; // legacy alias
    @Input() parentRow: TableRowData; // for expanded rows
    @Input() plateType: LicensePlateType = 'incoming';

    get rowData(): TableRowData {
        return this.row || this.item;
    }

    get displayValue(): string {
        if (this.plateType === 'incoming') {
            return hasCarrierNumberPlateIncoming(this.rowData)
                ? this.rowData.carrierNumberPlateIncoming || ''
                : '';
        } else {
            const rowPlate = hasCarrierNumberPlateOutgoing(this.rowData)
                ? this.rowData.carrierNumberPlateOutgoing
                : undefined;
            const parentPlate = hasCarrierNumberPlateOutgoing(this.parentRow)
                ? this.parentRow.carrierNumberPlateOutgoing
                : undefined;

            return rowPlate || parentPlate || '';
        }
    }
}
